/* Justyol — COD checkout page logic (/cart?view=checkout).
   Reads the cart lines rendered by Liquid, validates the form, POSTs to
   window.JY_COD_ENDPOINT, clears the cart and shows the success state. */
(function () {
  'use strict';

  var root = document.querySelector('[data-jy-codc]');
  if (!root) return;

  var isAr = (document.documentElement.lang || '').indexOf('ar') === 0;
  var form = root.querySelector('[data-jy-codc-form]');
  var doneEl = root.querySelector('[data-jy-codc-done]');
  var errEl = root.querySelector('[data-jy-codc-err]');
  var citySel = root.querySelector('[data-jy-codc-city]');
  var submitBtn = root.querySelector('[data-jy-codc-submit]');
  if (!form) return; /* empty cart state */

  var items = [];
  var discountCents = 0;
  var cartCents = 0;
  var feeCents = 0;
  var freeItem = false; /* a cart line ships free on its own (metafield/winners) */
  var freeCents = 0;
  /* first-order-from-the-app welcome discount (in-app webview) */
  var appOfferMad = 0; /* MAD off to reflect in the total (0 = none) */
  var appReplaces = false; /* app promo beat the cart discount + coupon → replaces them */
  var appOfferKey = ''; /* phone+subtotal already checked */
  var appOfferBusy = false;
  var appOfferDirty = false; /* a coupon/basket change landed mid-check */
  var orderIdemKey = ''; /* stable across retries of the same order; cleared on success */
  var orderInFlight = false; /* one order request at a time: the sticky-bar button and the
     in-form button both submit this form, and only one gets disabled by setLoading */
  function jyUuid() {
    try {
      if (crypto && crypto.randomUUID) return crypto.randomUUID();
    } catch (e) { /* noop */ }
    return 'k' + Date.now() + Math.random().toString(16).slice(2);
  }
  try {
    var payloadData = JSON.parse(root.querySelector('[data-jy-codc-items]').textContent);
    if (Array.isArray(payloadData)) {
      items = payloadData; /* older markup: bare array */
    } else {
      items = payloadData.items || [];
      discountCents = payloadData.discount || 0;
      cartCents = payloadData.totalCents || 0;
      feeCents = payloadData.feeCents || 0;
      freeCents = payloadData.freeCents || 0;
      freeItem = payloadData.freeItem === true;
    }
  } catch (e) {
    items = [];
  }

  /* lastGrand (cents) is declared HERE — before the funnel IIFE and before
     refreshTotals — so the value the IIFE computes below survives. Declaring it
     with `var` further down would hoist-reset it to 0 after this ran, zeroing
     out abandoned-cart lead totals and the Purchase pixel value. */
  var lastGrand = 0;
  /* funnel entry — value is the cart total incl. estimated shipping */
  (function () {
    /* free-shipping qualifies on GROSS goods (cartCents is net of the cart
       discount; add it back), mirroring the Worker's authoritative check */
    var freeOk0 = (cartCents + discountCents) >= freeCents || freeItem;
    lastGrand = cartCents + (freeOk0 ? 0 : feeCents);
    if (items.length) {
      /* eventID so Meta can dedupe this IC against any future server copy */
      var icEid = 'jy-ic-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
      track('InitiateCheckout', 'begin_checkout', { value: lastGrand / 100, num: items.length, eventId: icEid });
      beaconIcCapi(icEid, lastGrand);
    }
  })();

  /* Paint the spend & save progress bar once on open. On web, refreshTotals()
     isn't called until the shopper touches a coupon/qty/credit (checkAppOffer
     bails early off-app and the totals are server-rendered), so without this the
     bar would stay hidden until the first interaction. */
  if (window.JY_TIER && window.JY_TIER.render) {
    window.JY_TIER.render((cartCents + discountCents) / 100, (cartCents + discountCents) > 0 ? (discountCents / (cartCents + discountCents)) * 100 : 0);
  }

  /* ---- coupon (loyalty coupons + fixed-amount store codes) ---- */
  var couponCode = '';
  var couponCents = 0;
  var lastRejectedCoupon = ''; /* a code we already tried and the worker rejected */
  var couponMin = 0; /* MAD — the code only applies from this goods subtotal (referral: 150) */
  /* goods before any discount — the basis the Worker checks the minimum on */
  function couponLive() {
    return !!couponCode && !(couponMin > 0 && cartCents + discountCents < couponMin * 100);
  }
  var couponInput = root.querySelector('[data-jy-codc-cin]');
  var couponBtn = root.querySelector('[data-jy-codc-capply]');
  var couponErr = root.querySelector('[data-jy-codc-cerr]');

  function fmtMoney(cents) {
    // round to whole dirhams to match the store's money filter (which the line
    // items use) — otherwise a fractional discount makes the total read e.g.
    // "38.09 Dhs" next to whole-dirham line items that don't reconcile
    var n = Math.round((cents || 0) / 100);
    return n.toLocaleString(isAr ? 'ar-MA' : 'fr-FR') + ' ' + (isAr ? 'درهم' : 'Dhs');
  }

  /* ---- ad/analytics events: the custom form bypasses Shopify's checkout,
     so Meta/GA4 lose the funnel unless we fire it ourselves ---- */

  /* server-side IC bridge: beacon the same eventID + browser ids to the
     worker, which mirrors this InitiateCheckout via the Conversions API —
     Meta dedupes on the shared id, lifting event coverage past 75%. */
  function beaconIcCapi(icEid, valueCents) {
    try {
      var ep = 'https://justyol-cod.justyol.workers.dev';
      try {
        if (window.JY_COD_ENDPOINT) ep = new URL(window.JY_COD_ENDPOINT).origin;
      } catch (e0) {}
      var pc = window.JY_FX && JY_FX.pixelContext ? JY_FX.pixelContext() : {};
      var body = JSON.stringify({
        e: 'ic_capi',
        eventId: icEid,
        fbp: pc.fbp || '',
        fbc: pc.fbc || '',
        url: pc.url || location.href,
        value: Math.round(valueCents) / 100,
      });
      if (!(navigator.sendBeacon && navigator.sendBeacon(ep + '/t', body))) {
        fetch(ep + '/t', { method: 'POST', body: body, keepalive: true }).catch(function () {});
      }
    } catch (e) {
      /* analytics only */
    }
  }

  function track(fbName, gaName, data) {
    var contents = (items || []).map(function (it) {
      return { id: String(it.productId || it.variantId || it.id || ''), quantity: it.quantity || 1 };
    }).filter(function (c) { return c.id; });
    var ids = contents.map(function (c) { return c.id; });
    try {
      if (window.fbq) fbq('track', fbName, { value: data.value, currency: 'MAD', num_items: data.num, content_type: 'product', content_ids: ids, contents: contents, jy_platform: window.JY_IS_APP === true ? 'app' : 'web' }, data.eventId ? { eventID: data.eventId } : undefined);
    } catch (e) { /* noop */ }
    try {
      var gaItems = contents.map(function (c) { return { item_id: c.id, quantity: c.quantity }; });
      var p = { value: data.value, currency: 'MAD', items: gaItems };
      if (data.id) p.transaction_id = data.id;
      p.jy_platform = window.JY_IS_APP === true ? 'app' : 'web'; /* segment funnel by app vs web */
      if (window.gtag) gtag('event', gaName, p);
      else if (window.dataLayer) window.dataLayer.push(Object.assign({ event: gaName }, p));
    } catch (e) { /* noop */ }
    try {
      /* Google Ads CONVERSION (AW-...). The cart COD flow fires inline (it does
         NOT redirect to /pages/merci like the express flow, which fires it via
         JY_FX.purchase there), so it must send the conversion itself — otherwise
         cart-checkout COD purchases never reach Google Ads. Deduped by
         transaction_id; Enhanced Conversions attach the hashed phone when on. */
      if (fbName === 'Purchase' && window.gtag && window.JY_GADS && window.JY_GADS.sendTo) {
        if (window.JY_GADS.enhanced && data.phone) {
          var gph = String(data.phone).replace(/[^\d]/g, '');
          if (gph.charAt(0) === '0') gph = '212' + gph.slice(1);
          else if (gph.length === 9) gph = '212' + gph;
          if (gph) gtag('set', 'user_data', { phone_number: '+' + gph });
        }
        gtag('event', 'conversion', {
          send_to: window.JY_GADS.sendTo,
          value: data.value,
          currency: 'MAD',
          transaction_id: data.id || undefined,
        });
      }
    } catch (e) { /* noop */ }
    try {
      if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
        window.flutter_inappwebview.callHandler('jyEvent', { name: fbName, value: data.value || 0, currency: 'MAD', contentIds: ids });
      }
    } catch (e) { /* noop */ }
    try {
      if (window.ttq) ttq.track(fbName === 'Purchase' ? 'CompletePayment' : fbName, { value: data.value, currency: 'MAD', content_id: ids[0], content_type: 'product', contents: contents, jy_platform: window.JY_IS_APP === true ? 'app' : 'web' });
    } catch (e) { /* noop */ }
  }
  /* lastGrand is declared above (before the funnel IIFE); do not re-declare it
     here or `var` hoisting resets it to 0. It stays fresh via refreshTotals. */
  var purchaseEventId = ''; /* shared with the backend CAPI for dedup */
  /* ---- store credit (portal session required) ---- */
  var creditBalance = 0; /* cents */
  var useCredit = false;
  var portalToken = '';
  try {
    portalToken = localStorage.getItem('jy_portal_token') || '';
  } catch (e) {
    /* noop */
  }

  function refreshTotals() {
    /* first-order-from-the-app discount (before credit; the worker applies the
       same amount authoritatively at order creation). When it wins it REPLACES
       the cart discount + coupon (bigger-wins, never stacked): work from goods
       (cartCents already has the cart discount baked in, so add it back) and
       drop the coupon, so the total reads goods − appPromo. */
    var couponShown = appReplaces || !couponLive() ? 0 : couponCents;
    /* code kept but the basket is under its minimum → say how far, never apply */
    var cpMin = root.querySelector('[data-jy-codc-cmin]');
    if (couponBtn && couponCode && !couponBtn.disabled) {
      /* "applied" only when it really is; under its minimum it's just saved */
      couponBtn.textContent = couponLive() ? (isAr ? 'مطبّق ✓' : 'Appliqué ✓') : (isAr ? 'محفوظ' : 'Enregistré');
      couponBtn.classList.toggle('is-ok', couponLive());
    }
    if (cpMin) {
      var cpGap = couponCode && couponMin > 0 ? couponMin * 100 - (cartCents + discountCents) : 0;
      cpMin.hidden = !(cpGap > 0);
      if (cpGap > 0) {
        cpMin.textContent = isAr
          ? 'الكود ' + couponCode + ' صالح للطلبات من ' + couponMin + ' درهم — زيد ' + fmtMoney(cpGap) + ' باش يتخصم ' + fmtMoney(couponCents)
          : 'Le code ' + couponCode + ' est valable dès ' + couponMin + ' Dhs — ajoutez ' + fmtMoney(cpGap) + ' pour ' + fmtMoney(couponCents) + ' de remise';
      }
    }
    var base = appReplaces ? cartCents + discountCents : cartCents;
    var afterCoupon = Math.max(0, base - couponShown);
    /* Free-shipping is decided on GROSS goods (before the cart discount AND the
       coupon), exactly like the Worker — a coupon never removes free shipping.
       goodsCents = cartCents + discountCents. */
    var freeOk = (cartCents + discountCents) >= freeCents || freeItem;
    var grand = afterCoupon + (freeOk ? 0 : feeCents);
    var appCents = appOfferMad > 0 ? Math.round(appOfferMad * 100) : 0;
    appCents = Math.min(appCents, grand);
    grand -= appCents;
    var approw = root.querySelector('[data-jy-codc-approw]');
    var apamt = root.querySelector('[data-jy-codc-app]');
    if (approw) approw.hidden = appCents <= 0;
    if (apamt) apamt.textContent = '−' + fmtMoney(appCents);
    /* when the app promo REPLACES the cart discount, the Liquid-rendered
       "Remise −X" row is stale (that discount is added back into base) — hide it
       so the on-screen breakdown reconciles with the total */
    var cartDiscRow = root.querySelector('[data-jy-codc-cartdiscrow]');
    if (cartDiscRow) cartDiscRow.hidden = appReplaces;
    /* credit pays the GOODS only (after coupon/app promo) — never shipping,
       same cap as the Worker, so the shown total is what's collected */
    var creditApplied = useCredit && creditBalance > 0 ? Math.min(creditBalance, Math.max(0, afterCoupon - appCents)) : 0;
    grand -= creditApplied;
    var crrow = root.querySelector('[data-jy-codc-crrow]');
    var cramt = root.querySelector('[data-jy-codc-cramt]');
    if (crrow) crrow.hidden = creditApplied <= 0;
    if (cramt) cramt.textContent = '−' + fmtMoney(creditApplied);
    var crow = root.querySelector('[data-jy-codc-crow]');
    var camt = root.querySelector('[data-jy-codc-camt]');
    var clabel = root.querySelector('[data-jy-codc-clabel]');
    if (crow) crow.hidden = couponShown <= 0;
    if (camt) camt.textContent = '−' + fmtMoney(couponShown);
    if (clabel && couponCode) {
      clabel.textContent = (isAr ? 'كوبون ' : 'Coupon ') + couponCode;
    }
    /* the top "have a code?" link doubles as the applied-code confirmation */
    var hc = root.querySelector('[data-jy-codc-havecode]');
    var hct = root.querySelector('[data-jy-codc-havecode-t]');
    if (hc && hct) {
      var hcOn = couponShown > 0;
      hc.classList.toggle('is-ok', hcOn);
      hct.textContent = hcOn
        ? (isAr ? 'كود ' + couponCode + ' مطبّق ✓ (−' + fmtMoney(couponShown) + ')' : 'Code ' + couponCode + ' appliqué ✓ (−' + fmtMoney(couponShown) + ')')
        : (isAr ? 'عندك كود خصم؟' : 'Vous avez un code promo ?');
    }
    var shipval = root.querySelector('[data-jy-codc-shipval]');
    if (shipval && cartCents) {
      /* free-shipping is decided on gross goods, so a coupon can never remove it
         — no false "your coupon dropped you below the threshold" note */
      shipval.innerHTML = freeOk
        ? '<span class="jy-codc__free">' + (isAr ? 'مجاني ✓' : 'Offerte ✓') + '</span>'
        : fmtMoney(feeCents);
    }
    var totalEl = root.querySelector('[data-jy-codc-total]');
    var barEl = root.querySelector('[data-jy-codc-bartotal]');
    if (totalEl && cartCents) totalEl.textContent = fmtMoney(grand);
    if (barEl && cartCents) barEl.textContent = fmtMoney(grand);
    lastGrand = grand;
    /* spend & save: progress to the next discount tier. The tier thresholds are
       evaluated by Shopify on the pre-discount merchandise subtotal, so feed the
       goods total (cartCents already has the tier discount subtracted — add it
       back), NOT the discounted total, or "remaining to next tier" reads high. */
    if (window.JY_TIER && window.JY_TIER.render) {
      window.JY_TIER.render((cartCents + discountCents) / 100, (cartCents + discountCents) > 0 ? (discountCents / (cartCents + discountCents)) * 100 : 0);
    }
  }
  function couponErrMsg(code) {
    var m = {
      invalid_coupon: isAr ? 'الكود غير صحيح.' : 'Code invalide.',
      coupon_used: isAr ? 'هذا الكوبون مستعمل من قبل.' : 'Ce coupon a déjà été utilisé.',
      coupon_expired: isAr ? 'انتهت صلاحية الكوبون.' : 'Ce coupon a expiré.',
      coupon_unsupported: isAr ? 'هذا الكود غير مدعوم هنا.' : 'Ce code n’est pas utilisable ici.',
      coupon_min_spend: isAr ? 'هذا الكوبون يتطلب حدًّا أدنى للطلب.' : "Ce coupon exige un montant minimum de commande.",
      coupon_min_qty: isAr ? 'هذا الكوبون يتطلب عددًا أدنى من القطع.' : 'Ce coupon exige un nombre minimum d’articles.',
      ref_own_code: isAr ? 'لا يمكنك استعمال كود الإحالة الخاص بك.' : 'Vous ne pouvez pas utiliser votre propre code.',
      ref_not_first: isAr ? 'كود الإحالة صالح لأول طلب فقط.' : 'Ce code est réservé à la première commande.',
    };
    return m[code] || (isAr ? 'تعذّر التحقق من الكود.' : 'Impossible de vérifier le code.');
  }
  function setCouponErr(msg) {
    if (!couponErr) return;
    couponErr.hidden = !msg;
    if (msg) couponErr.textContent = msg;
  }
  function applyCoupon(code) {
    if (!code || !window.JY_COD_ENDPOINT || !couponBtn) return;
    couponBtn.disabled = true;
    var oldLbl = couponBtn.textContent;
    couponBtn.textContent = '…';
    setCouponErr(false);
    fetch(String(window.JY_COD_ENDPOINT).replace(/\/+$/, '') + '/coupon/check', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: code }),
    })
      .then(function (r) {
        return r.json().catch(function () {
          return {};
        });
      })
      .then(function (j) {
        if (!j.ok) throw new Error(j.error || 'invalid_coupon');
        couponCode = j.code;
        couponCents = Math.round(Number(j.mad) * 100);
        couponMin = Number(j.min) || 0;
        lastRejectedCoupon = ''; /* a valid code cleared the rejection */
        refreshTotals();
        checkAppOffer(); /* coupon changed the "other discount" → re-evaluate bigger-wins */
        if (couponInput) couponInput.value = j.code;
        couponBtn.textContent = isAr ? 'مطبّق ✓' : 'Appliqué ✓';
        couponBtn.classList.add('is-ok');
      })
      .catch(function (e) {
        couponCode = '';
        couponCents = 0;
        lastRejectedCoupon = code; /* remember it so Confirm doesn't re-loop on it */
        refreshTotals();
        checkAppOffer();
        couponBtn.textContent = oldLbl;
        setCouponErr(couponErrMsg(String(e && e.message)));
      })
      .finally(function () {
        couponBtn.disabled = false;
      });
  }
  var haveCode = root.querySelector('[data-jy-codc-havecode]');
  if (haveCode) {
    haveCode.addEventListener('click', function (e) {
      var box = root.querySelector('[data-jy-codc-coupon]');
      if (!box) return;
      e.preventDefault();
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      /* focus after the scroll so the mobile keyboard doesn't fight it */
      if (couponInput && !couponCode) setTimeout(function () { try { couponInput.focus({ preventScroll: true }); } catch (e2) {} }, 450);
    });
  }
  if (couponBtn) {
    couponBtn.addEventListener('click', function () {
      applyCoupon((couponInput && couponInput.value ? couponInput.value : '').trim().toUpperCase());
    });
  }
  if (couponInput) {
    couponInput.addEventListener('keydown', function (e) {
      /* Enter applies the code — the field lives outside the order form */
      if (e.key === 'Enter') {
        e.preventDefault();
        applyCoupon(couponInput.value.trim().toUpperCase());
      }
    });
    couponInput.addEventListener('input', function () {
      /* editing after apply → coupon must be re-validated */
      if (couponCode && couponInput.value.trim().toUpperCase() !== couponCode) {
        couponCode = '';
        couponCents = 0;
        couponBtn.textContent = isAr ? 'تطبيق' : 'Appliquer';
        couponBtn.classList.remove('is-ok');
        refreshTotals();
        checkAppOffer();
      }
    });
  }
  /* the account portal drops a coupon here (Utiliser / Copier) → auto-apply */
  try {
    var savedCoupon = (localStorage.getItem('jy_coupon') || '').trim();
    if (savedCoupon && couponInput) {
      couponInput.value = savedCoupon;
      applyCoupon(savedCoupon.toUpperCase());
    }
  } catch (e) {
    /* noop */
  }

  /* logged-in customers with a positive balance get the credit toggle */
  if (portalToken && window.JY_COD_ENDPOINT) {
    fetch(String(window.JY_COD_ENDPOINT).replace(/\/+$/, '') + '/credit/get', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: portalToken }),
    })
      .then(function (r) {
        return r.json().catch(function () {
          return {};
        });
      })
      .then(function (j) {
        if (!j.ok || !(j.balance > 0)) return;
        creditBalance = j.balance;
        useCredit = true;
        var wrap = root.querySelector('[data-jy-codc-credit]');
        var bal = root.querySelector('[data-jy-codc-creditbal]');
        if (bal) bal.textContent = creditBalance % 100 === 0 ? String(creditBalance / 100) : (creditBalance / 100).toFixed(2);
        if (wrap) {
          wrap.hidden = false;
          var chk = wrap.querySelector('[data-jy-codc-creditchk]');
          if (chk) {
            chk.addEventListener('change', function () {
              useCredit = chk.checked;
              refreshTotals();
            });
          }
        }
        refreshTotals();
      })
      .catch(function () {
        /* no credit UI on failure */
      });
  }

  /* ---- payment method selector (COD default / card via native+Payzone) ---- */
  var payMethod = 'cod';
  var payWrap = root.querySelector('[data-jy-codc-pay]');
  if (payWrap) {
    payWrap.addEventListener('change', function () {
      var checked = payWrap.querySelector('input[name="paymethod"]:checked');
      payMethod = checked ? checked.value : 'cod';
      payWrap.querySelectorAll('.jy-codc__pay-opt').forEach(function (opt) {
        var inp = opt.querySelector('input');
        opt.classList.toggle('is-on', !!(inp && inp.checked));
      });
      /* card → fields collected by the secure payment flow; bank/cod need them */
      var needFields = payMethod !== 'card';
      [root.querySelector('[data-jy-codc-shiptitle]'), root.querySelector('.jy-codx__fields')].forEach(function (el) {
        if (el) el.hidden = !needFields;
      });
      var reassure = root.querySelector('.jy-codx__reassure');
      if (reassure) reassure.hidden = payMethod !== 'cod'; /* cash copy is COD-only */
      var banknote = root.querySelector('[data-jy-codc-banknote]');
      if (banknote) banknote.hidden = payMethod !== 'bank';
      var lbl = submitBtn && submitBtn.querySelector('.jy-codx__submit-lbl');
      if (lbl) {
        lbl.textContent =
          payMethod === 'card'
            ? isAr
              ? 'متابعة الدفع الآمن'
              : 'Continuer vers le paiement'
            : isAr
              ? 'تأكيد الطلب'
              : 'Confirmer la commande';
      }
      showErr(false);
    });
  }

  /* cities */
  if (citySel && window.JY_CITIES && citySel.options.length <= 1) {
    var frag = document.createDocumentFragment();
    window.JY_CITIES.forEach(function (c) {
      var o = document.createElement('option');
      o.value = c;
      o.textContent = c;
      frag.appendChild(o);
    });
    citySel.appendChild(frag);
  }

  /* ---- top-cities quick chips: one tap fills the 500+ option select ----
     Chip labels ("Casablanca", "Fès") don't always match the option casing/accents
     in JY_CITIES ("CASABLANCA", "Fes"), so match normalised (upper + no diacritics)
     and add the city if it's missing — otherwise the tap set no value and validation
     kept saying "Choisissez votre ville". */
  function jyNormCity(s) {
    return (s || '').toString().trim().toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function jySyncCityChips() {
    if (!citySel) return;
    var cur = jyNormCity(citySel.value);
    root.querySelectorAll('[data-jy-city-chip]').forEach(function (c) {
      c.classList.toggle('is-on', jyNormCity(c.getAttribute('data-jy-city-chip')) === cur && cur !== '');
    });
  }
  function jySelectCity(name) {
    if (!citySel) return;
    var target = jyNormCity(name);
    var matched = '';
    for (var i = 0; i < citySel.options.length; i++) {
      if (citySel.options[i].value && jyNormCity(citySel.options[i].value) === target) {
        matched = citySel.options[i].value;
        break;
      }
    }
    if (!matched) {
      var o = document.createElement('option');
      o.value = name;
      o.textContent = name;
      citySel.appendChild(o);
      matched = name;
    }
    citySel.value = matched;
    jySyncCityChips();
  }
  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-jy-city-chip]');
    if (!chip || !citySel) return;
    jySelectCity(chip.getAttribute('data-jy-city-chip'));
  });
  if (citySel) {
    citySel.addEventListener('change', jySyncCityChips);
  }

  /* ---- one-tap add-ons (under the free-shipping bar) ---- */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jy-codc-addon]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    var old = btn.textContent;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.getAttribute('data-jy-codc-addon'), 10), quantity: 1 }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add_failed');
        /* park the in-progress form so the reload (which re-renders totals) never
           wipes what the shopper already typed at this high-intent moment */
        try {
          sessionStorage.setItem(
            'jy_cod_draft',
            JSON.stringify({
              name: (form.querySelector('[name="name"]') || {}).value || '',
              phone: (form.querySelector('[name="phone"]') || {}).value || '',
              address: (form.querySelector('[name="address"]') || {}).value || '',
              city: citySel ? citySel.value : '',
            })
          );
        } catch (e) {
          /* noop */
        }
        window.location.reload(); /* server re-renders totals + threshold state */
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = old;
      });
  });

  /* ---- abandoned-form capture: once a valid phone is typed, park the
     lead in the Worker so next/Zoko can send a WhatsApp nudge. Cleared
     server-side the moment the order completes. ---- */
  var abandonLast = 0;
  function captureAbandoned() {
    if (!window.JY_COD_ENDPOINT || (doneEl && !doneEl.hidden)) return;
    var phoneEl = form.querySelector('[name="phone"]');
    var phone = phoneEl ? phoneEl.value.trim() : '';
    if (phone.replace(/[^\d]/g, '').length < 9) return;
    var now = Date.now();
    if (now - abandonLast < 60000) return; /* at most once a minute */
    abandonLast = now;
    var nameEl = form.querySelector('[name="name"]');
    fetch(String(window.JY_COD_ENDPOINT).replace(/\/+$/, '') + '/abandoned', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        phone: phone,
        name: nameEl ? nameEl.value.trim() : '',
        city: citySel ? citySel.value : '',
        items: items,
        total: lastGrand,
        src: 'checkout',
        website: '',
      }),
    }).catch(function () {
      /* recovery is best-effort */
    });
  }
  form.addEventListener('change', function () {
    captureAbandoned();
    checkAppOffer();
  });
  (function () {
    var pEl = form.querySelector('[name="phone"]');
    if (pEl) {
      pEl.addEventListener('blur', function () {
        captureAbandoned();
        checkAppOffer();
      });
    }
  })();

  /* in-app only (?app=1 → window.JY_IS_APP): ask the backend whether this phone
     gets the first-order welcome discount, show it (or an "add X more" nudge),
     and reflect it in the total. Display only — enforced server-side at order
     creation. */
  function checkAppOffer() {
    if (window.JY_IS_APP !== true || !window.JY_COD_ENDPOINT || !cartCents) return;
    // in-app promo: any app order clears it (no phone / first-order check).
    // send GOODS (pre cart-discount) so the 250 threshold matches the worker,
    // which computes from the pre-discount subtotal. exact (unrounded) so the
    // boundary lines up at 250.
    var otherCents = discountCents + (couponLive() ? couponCents : 0);
    var goodsCents = cartCents + discountCents;
    var subMad = goodsCents / 100;
    var key = 's:' + subMad + ':' + otherCents;
    if (appOfferKey === key) return;
    /* a check is running — re-run for the latest coupon/basket rather than
       dropping this one and leaving a stale discount on screen */
    if (appOfferBusy) { appOfferDirty = true; return; }
    appOfferBusy = true;
    fetch(String(window.JY_COD_ENDPOINT).replace(/\/+$/, '') + '/app/first-order-offer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ subtotal: subMad }),
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        appOfferKey = key;
        var more = root.querySelector('[data-jy-codc-appmore]');
        if (j && j.ok && j.eligible) {
          var cand = j.qualifies ? j.discount || 0 : 0;
          // exclusive — bigger wins. The promo only shows if it beats the cart
          // discount + coupon; then it REPLACES them (appReplaces).
          if (cand > 0 && Math.round(cand * 100) > otherCents) {
            appOfferMad = cand;
            appReplaces = otherCents > 0;
          } else {
            appOfferMad = 0;
            appReplaces = false;
          }
          if (more) {
            // below entry tier → nudge to unlock it; already in a tier but a
            // bigger one is reachable → nudge to the next threshold (AOV)
            var nudgeAmt = j.qualifies ? j.remainingToNext : j.remaining;
            var nudgeOff = j.qualifies ? j.nextOffer : j.offer;
            if (nudgeAmt && nudgeOff) {
              more.hidden = false;
              more.textContent = isAr
                ? 'ضِف ' + Math.ceil(nudgeAmt) + ' درهم واحصل على خصم ' + nudgeOff + ' درهم على طلبك من التطبيق 🎁'
                : 'Ajoutez ' + Math.ceil(nudgeAmt) + ' Dhs et obtenez ' + nudgeOff + ' Dhs de remise sur votre commande app 🎁';
            } else {
              more.hidden = true;
            }
          }
        } else {
          appOfferMad = 0;
          appReplaces = false;
          if (more) more.hidden = true;
        }
        refreshTotals();
      })
      .catch(function () {
        /* network blip — clear any stale promo rather than leave it painted */
        appOfferMad = 0;
        appReplaces = false;
        appOfferKey = '';
        refreshTotals();
      })
      .finally(function () {
        appOfferBusy = false;
        if (appOfferDirty) { appOfferDirty = false; checkAppOffer(); }
      });
  }

  /* ---- prefill: an in-progress form parked before an add-on reload wins over
     the saved-customer details (session draft is consumed once) ---- */
  var CUST_KEY = 'jy_cod_customer';
  try {
    var draft = null;
    try {
      draft = JSON.parse(sessionStorage.getItem('jy_cod_draft') || 'null');
    } catch (e2) {
      /* noop */
    }
    if (draft) sessionStorage.removeItem('jy_cod_draft');
    var savedCust = JSON.parse(localStorage.getItem(CUST_KEY) || 'null');
    var src = draft || savedCust;
    if (src) {
      ['name', 'phone', 'address'].forEach(function (k) {
        var inp = form.querySelector('[name="' + k + '"]');
        if (inp && !inp.value) inp.value = src[k] || '';
      });
      /* jySelectCity normalizes case/diacritics + appends unknown cities, so the
         restore/prefill can't silently no-op like a raw citySel.value would */
      if (citySel && !citySel.value && src.city) jySelectCity(src.city);
    }
  } catch (e) {
    /* noop */
  }
  checkAppOffer(); /* prefilled phone (returning customer) → check right away */
  function saveCustomer(c) {
    try {
      localStorage.setItem(CUST_KEY, JSON.stringify(c));
    } catch (e) {
      /* noop */
    }
  }

  function showErr(msg) {
    if (!errEl) return;
    errEl.hidden = !msg;
    if (msg) {
      errEl.textContent = msg;
      /* the submit lives in the sticky bar — bring the error into view */
      errEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  function validPhone(v) {
    var d = (v || '').replace(/[^\d]/g, '');
    /* Moroccan mobile: strip +212 or the trunk 0, then require the 9 national
       digits starting 5/6/7 — blocks the typos that create uncontactable COD orders. */
    if (d.slice(0, 3) === '212') d = d.slice(3);
    else if (d.charAt(0) === '0') d = d.slice(1);
    return d.length === 9 && /^[567]/.test(d);
  }
  function setLoading(on) {
    if (!submitBtn) return;
    submitBtn.disabled = on;
    var spin = submitBtn.querySelector('.jy-codx__spin');
    var lbl = submitBtn.querySelector('.jy-codx__submit-lbl');
    if (spin) spin.hidden = !on;
    if (lbl) lbl.style.opacity = on ? '0.5' : '1';
  }

  /* copy RIB */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jy-codc-copy]');
    if (!btn) return;
    var num = root.querySelector('[data-jy-codc-ribnum]');
    if (!num || !navigator.clipboard) return;
    navigator.clipboard.writeText(num.textContent.trim()).then(function () {
      var old = btn.textContent;
      btn.textContent = isAr ? 'تم ✓' : 'Copié ✓';
      setTimeout(function () {
        btn.textContent = old;
      }, 1600);
    });
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (orderInFlight) return;
    if (payMethod === 'card') {
      /* card / bank transfer → native checkout, which hands off to Payzone's
         hosted payment page */
      window.location.href = '/checkout';
      return;
    }
    var fd = new FormData(form);
    var name = (fd.get('name') || '').trim();
    var phone = (fd.get('phone') || '').trim();
    var city = (fd.get('city') || '').trim();
    var address = (fd.get('address') || '').trim();

    if (name.length < 3) return showErr(isAr ? 'من فضلك اكتب اسمك.' : 'Veuillez saisir votre nom.');
    if (!validPhone(phone)) return showErr(isAr ? 'رقم هاتف غير صحيح.' : 'Numéro de téléphone invalide.');
    if (!city) return showErr(isAr ? 'اختر مدينتك.' : 'Choisissez votre ville.');
    if (address.length < 5) return showErr(isAr ? 'اكتب عنوانك بالتفصيل.' : 'Saisissez votre adresse.');
    if (!items.length) return showErr(isAr ? 'سلتك فارغة.' : 'Votre panier est vide.');
    /* a typed-but-unapplied coupon must never be silently dropped: validate it
       now and ask for one more tap once the totals reflect it. BUT if the code
       was already tried and rejected, don't re-loop — let the order through
       without it (the coupon error is already shown). Otherwise an invalid code
       left in the field would block Confirm forever. */
    var typedCoupon = couponInput ? couponInput.value.trim().toUpperCase() : '';
    if (typedCoupon && typedCoupon !== couponCode && typedCoupon !== lastRejectedCoupon) {
      applyCoupon(typedCoupon);
      return showErr(
        isAr
          ? 'جارٍ التحقق من كود الخصم — راجع الإجمالي ثم أكّد الطلب.'
          : 'Vérification du code promo — vérifiez le total puis confirmez.'
      );
    }
    showErr(false);

    var endpoint = window.JY_COD_ENDPOINT;
    if (!endpoint) {
      return showErr(isAr ? 'خدمة الطلب غير مفعّلة بعد.' : "Le service de commande n'est pas encore activé.");
    }

    setLoading(true);
    orderInFlight = true;
    var pctx = window.JY_FX && JY_FX.pixelContext ? JY_FX.pixelContext() : {};
    purchaseEventId = pctx.eventId;
    /* same key across retries of this order so a lost response can't double-order */
    if (!orderIdemKey) orderIdemKey = jyUuid();
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        idempotencyKey: orderIdemKey,
        items: items,
        discount: discountCents,
        coupon: couponLive() ? couponCode : undefined,
        credit: useCredit && creditBalance > 0 ? true : undefined,
        token: useCredit && creditBalance > 0 ? portalToken : undefined,
        name: name,
        phone: phone,
        city: city,
        address: address,
        website: (fd.get('website') || '').trim(),
        payMethod: payMethod,
        freeShip: freeItem,
        app: window.JY_IS_APP === true,
        locale: isAr ? 'ar' : 'fr',
        pixel: pctx,
      }),
    })
      .then(function (r) {
        return r
          .json()
          .catch(function () {
            return {};
          })
          .then(function (j) {
            return { ok: r.ok, body: j };
          });
      })
      .then(function (res) {
        if (!res.ok || !res.body || res.body.ok === false) {
          var oErr = new Error((res.body && res.body.error) || 'error');
          if (res.body) {
            oErr.available = res.body.available;
            oErr.item = res.body.item;
            oErr.blocked = res.body.blocked;
          }
          throw oErr;
        }
        orderIdemKey = ''; /* next order gets a fresh idempotency key */
        saveCustomer({ name: name, phone: phone, city: city, address: address });
        /* fire the Worker's authoritative charged total (matches the Shopify order
           + server CAPI value exactly), falling back to the client estimate */
        /* merged = folded into this phone's order from a few minutes ago; it's
           not a new purchase, so don't count one */
        if (!res.body.merged) track('Purchase', 'purchase', { value: typeof res.body.total === 'number' ? res.body.total : lastGrand / 100, num: items.length, id: res.body.orderName || '', eventId: purchaseEventId, phone: phone });
        if (couponLive() && !appReplaces) {
          try {
            localStorage.removeItem('jy_coupon'); /* consumed */
          } catch (e2) {
            /* noop */
          }
        }
        var orderName = res.body.orderName || '';
        var ref = root.querySelector('[data-jy-codc-ref]');
        if (ref && orderName) {
          ref.textContent = (isAr ? 'رقم الطلب: ' : 'N° commande : ') + orderName;
        }
        /* merged: the same order reached the Worker twice at the same moment
           (double submit) — no second order was created; the shopper gets the
           first one's number. Say so, so the "old" number doesn't read as lost. */
        if (res.body.merged) {
          var mMsg = root.querySelector('[data-jy-codc-donemsg]');
          if (mMsg) {
            mMsg.textContent = isAr
              ? 'طلبك مسجّل بالفعل (' + orderName + ') — مش محتاج تبعته تاني. هنكلمك قريب للتأكيد قبل الشحن 📞'
              : 'Votre commande est déjà enregistrée (' + orderName + ') — inutile de la renvoyer. Nous vous appellerons pour confirmer avant l\u2019expédition 📞';
          }
        }
        /* service-intent WhatsApp on the success card */
        var waHelp = root.querySelector('[data-jy-codc-wahelp]');
        if (waHelp && window.JY_WA) {
          var helpTxt = isAr
            ? 'السلام، عندي سؤال عن طلبي ' + orderName
            : "Bonjour, j'ai une question sur ma commande " + orderName;
          waHelp.href =
            'https://wa.me/' + String(window.JY_WA).replace(/[^\d]/g, '') + '?text=' + encodeURIComponent(helpTxt);
          waHelp.hidden = false;
        }
        /* bank transfer: reveal the RIB block + WhatsApp receipt link */
        if (payMethod === 'bank') {
          var rib = root.querySelector('[data-jy-codc-rib]');
          if (rib) rib.hidden = false;
          var msg = root.querySelector('[data-jy-codc-donemsg]');
          if (msg) {
            msg.textContent = isAr
              ? 'حوّل المبلغ على الحساب التالي ثم أرسل الإيصال.'
              : 'Effectuez le virement sur le compte ci-dessous puis envoyez le reçu.';
          }
          var wa = root.querySelector('[data-jy-codc-wa]');
          if (wa && window.JY_WA) {
            var waTxt = isAr
              ? 'السلام، إيصال التحويل الخاص بالطلب ' + orderName
              : 'Bonjour, voici le reçu du virement pour la commande ' + orderName;
            wa.href = 'https://wa.me/' + String(window.JY_WA).replace(/[^\d]/g, '') + '?text=' + encodeURIComponent(waTxt);
          } else if (wa) {
            wa.hidden = true;
          }
        }
        /* empty the cart in the background; badge refreshes on next nav */
        fetch('/cart/clear.js', { method: 'POST' }).catch(function () {});
        /* swap to success state */
        form.hidden = true;
        var summary = root.querySelector('.jy-codc__summary');
        if (summary) summary.hidden = true;
        var costs = root.querySelector('.jy-codc__costs');
        if (costs) costs.hidden = true;
        var bar = root.querySelector('[data-jy-codc-bar]');
        if (bar) bar.hidden = true;
        doneEl.hidden = false;
        var doneH = doneEl.querySelector('h2');
        if (doneH) {
          doneH.setAttribute('tabindex', '-1');
          doneH.focus({ preventScroll: true }); /* keyboard/SR lands on the confirmation */
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch(function (err) {
        var code = String(err && err.message);
        if (code.indexOf('coupon') !== -1 || code === 'ref_not_first' || code === 'ref_own_code') {
          /* the order was rejected because of the coupon (e.g. min-spend). Drop
             it so Confirm doesn't re-send the same losing code in a loop, and
             tell the shopper what happened. */
          lastRejectedCoupon = couponCode || lastRejectedCoupon;
          couponCode = '';
          couponCents = 0;
          if (couponInput) couponInput.value = '';
          if (couponBtn) { couponBtn.textContent = isAr ? 'تطبيق' : 'Appliquer'; couponBtn.classList.remove('is-ok'); }
          if (code.indexOf('ref_') === 0 || code === 'coupon_used' || code === 'coupon_expired' || code === 'invalid_coupon') {
            try { localStorage.removeItem('jy_coupon'); } catch (e3) {} /* dead code — don't re-apply next visit */
          }
          try { refreshTotals(); checkAppOffer(); } catch (e2) {}
          showErr(couponErrMsg(code) + (isAr ? ' تم حذف الكود — راجع الإجمالي وأكّد الطلب.' : ' Code retiré — vérifiez le total et confirmez.'));
          return;
        }
        if (code === 'credit_phone_mismatch') {
          showErr(
            isAr
              ? 'لاستعمال رصيدك، استخدم نفس رقم الهاتف المسجّل في حسابك.'
              : 'Pour utiliser votre solde, saisissez le numéro lié à votre compte.'
          );
          return;
        }
        if (code === 'out_of_stock') {
          showErr(isAr ? 'نفد مخزون هذا المنتج 😔' : 'Ce produit est en rupture de stock 😔');
          return;
        }
        if (code === 'unavailable') {
          /* server sellability gate: an archived product or an out-of-stock
             variant slipped into the cart (e.g. went unavailable after it was
             added). Name it when we can so the shopper knows what to remove. */
          var bl = (err && err.blocked) || [];
          var blName = bl.length && bl[0] && bl[0].title ? bl[0].title : '';
          showErr(
            isAr
              ? (blName ? '«' + blName + '» ' : 'أحد المنتجات ') + 'لم يعد متوفّرًا — أزِله من السلة.'
              : (blName ? '« ' + blName + ' » ' : "L'un des produits ") + "n'est plus disponible — retirez-le du panier."
          );
          return;
        }
        if (code === 'insufficient_stock') {
          var nLeft = err && typeof err.available === 'number' ? err.available : 0;
          showErr(
            isAr
              ? 'بقي فقط ' + nLeft + ' قطعة من هذا المنتج — قلّل الكمية.'
              : 'Il ne reste que ' + nLeft + ' article(s) — réduisez la quantité.'
          );
          return;
        }
        if (code === 'processing') {
          showErr(
            isAr
              ? 'طلبك قيد التسجيل ✅ لا داعي لإعادة الإرسال، سنتصل بك قريباً.'
              : "Votre commande est en cours d'enregistrement ✅ inutile de renvoyer, nous vous appellerons."
          );
          return;
        }
        showErr(
          code === 'rate_limited'
            ? isAr
              ? 'محاولات كثيرة — انتظر دقيقة وحاول مجددًا.'
              : 'Trop de tentatives — patientez une minute.'
            : isAr
              ? 'تعذّر إرسال الطلب، حاول مجددًا.'
              : "Échec de l'envoi, réessayez."
        );
      })
      .finally(function () {
        orderInFlight = false;
        setLoading(false);
      });
  });
})();
